import { AutogenLayoutBrokerageWorkflowProfileList } from "./autogen/AutogenLayoutBrokerageWorkflowProfileList";


export class BrokerageWorkflowProfileList extends AutogenLayoutBrokerageWorkflowProfileList {

    override onLoad(): void {
        this.mainDataSource.search({});
    }
 }
